// extracted by mini-css-extract-plugin
export default {"input":"checkbox_input__unGoE","labelWrapper":"checkbox_labelWrapper__VLpqP"};